import { render, staticRenderFns } from "./active-menu-items.vue?vue&type=template&id=062b0f9a"
import script from "./active-menu-items.vue?vue&type=script&lang=js"
export * from "./active-menu-items.vue?vue&type=script&lang=js"
import style0 from "./active-menu-items.vue?vue&type=style&index=0&id=062b0f9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports